import React from 'react';
import cookies from 'browser-cookies';
import {
	bufferToBase64UrlEncoded,
	createRandomString,
	sha256,
} from '../utils/encoding';
import { useSiteConfig } from '../contexts';
import { getForgeLoginRedirectUrl } from '../services/forge.service';

interface ValidationParams {
	sourceId: string;
}

const defaultValidationParams: ValidationParams = {
	sourceId: '',
};

export const useAuth = () => {
	const { config } = useSiteConfig();

	const redirectToAutodesk = async () => {
		const codeVerifier = createRandomString(80);
		const sha256CodeVerifier = await sha256(codeVerifier);
		const codeChallenge = bufferToBase64UrlEncoded(sha256CodeVerifier);
		localStorage.setItem('codeVerifier', codeVerifier);
		const loginRedirectUrl = getForgeLoginRedirectUrl(
			config?.forge,
			window.location.origin + '/auth/forge/login',
			codeChallenge,
		);
		window.location.assign(loginRedirectUrl);
	};

	const hasValidToken = () => {
		const hasExpired = (expiryISOString: string) => {
			const now = new Date();
			const expiry = new Date(expiryISOString);
			return expiry > now;
		};

		const authToken = cookies.get('auth0.user.token');
		const authTokenExpiry = cookies.get('forge.expirationDate');

		return !!authToken && !!authTokenExpiry && hasExpired(authTokenExpiry);
	};

	const handleProjectInjectionAuthentication = (
		params: ValidationParams = defaultValidationParams,
	) => {
		const authToken = cookies.get('auth0.user.token');

		if (!authToken) {
			localStorage.setItem('forge.auth.sourceId', params.sourceId);
			redirectToAutodesk();
		}
	};

	return {
		hasValidToken,
		redirectToAutodesk,
		handleProjectInjectionAuthentication,
	};
};
